// extracted by mini-css-extract-plugin
module.exports = {"box":"invoices_box__240Tj","header":"invoices_header__1C-T-","body":"invoices_body__1_YLY","bodyItem":"invoices_bodyItem__2nbCd","footer":"invoices_footer__1Ykby"};